import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Button } from 'xm-spark';
import NewsUpdatesIcon from 'resources/svg/news-updates-icon.svg';
import CommunitySupportIcon from 'resources/svg/community-support-icon.svg';
import WorkshopScheduleIcon from 'resources/svg/workshop-schedule-icon.svg';
import styles from './Features.module.scss';

export default function Features({
  announcementOptions,
  isDarkMode,
  bgColorHex,
  bgFileName,
}) {
  const bgFileSuffix = isDarkMode ? 'dark' : 'light';
  const { body, linkText, linkUrl, title } = announcementOptions;

  return (
    <div
      className={classnames(styles.container, {
        [styles.announcementDarkMode]: isDarkMode,
      })}
      style={{ backgroundColor: bgColorHex }}
      data-testid="loginFeatures_announcementContent"
    >
      <div className={styles.quicklink} data-testid="loginFeatures_quicklinks">
        <div data-testid="loginFeatures_quicklink-newsAndUpdates">
          <NewsUpdatesIcon />
          <a href="https://support.xmatters.com/hc/en-us/categories/13165766713115">
            <FormattedMessage id="LOG_IN_FEATURES_NEWS_AND_UPDATES" />
          </a>
        </div>
        <div data-testid="loginFeatures_quicklink-communitySupport">
          <CommunitySupportIcon />
          <a href="https://support.xmatters.com/hc/en-us/community/topics">
            <FormattedMessage id="LOG_IN_FEATURES_COMMUNITY_AND_SUPPORT" />
          </a>
        </div>
        <div data-testid="loginFeatures_quicklink-workshopSchedule">
          <WorkshopScheduleIcon />
          <a href="https://workshops.xmatters.com/">
            <FormattedMessage id="LOG_IN_FEATURES_WORKSHOP_SCHEDULE" />
          </a>
        </div>
      </div>
      <img 
        className={styles.infoGraphic}
        data-testid="loginFeatures_infographic"
        alt="loginFeatures_infographic"
        src={`${window.location.origin}/assets/${bgFileName}-${bgFileSuffix}.svg`}
      />
      {title && <h1 data-testid="loginFeatures_announcementTitle">{title}</h1>}
      {body && <p data-testid="loginFeatures_announcementBody">{body}</p>}
      {linkUrl && linkText && (
        <Button
          className={styles.link}
          title={linkText}
          onClick={() => window.open(linkUrl, '_blank')}
          data-testid="loginFeatures_announcementLink"
          color="transparent"
        >
          {linkText}
        </Button>
      )}
    </div>
  );
}

Features.propTypes = {
  announcementOptions: PropTypes.objectOf(PropTypes.string).isRequired,
  bgColorHex: PropTypes.string,
  bgFileName: PropTypes.string.isRequired,
  isDarkMode: PropTypes.bool.isRequired,
};

Features.defaultProps = {
  bgColorHex: '',
};
